import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Currency,
  CurrencyUpdatePayload,
} from '../../../models/currency.model';

export const OperatorSettingsCurrencyActions = createActionGroup({
  source: 'Operator Settings Currency',
  events: {
    'Load Currencies': emptyProps(),
    'Load Currencies Success': props<{ currencies: Currency[] }>(),
    'Load Currencies Failure': props<{ error: string }>(),

    'Update Currency': props<{
      currencyShortCode: string;
      data: CurrencyUpdatePayload;
    }>(),
    'Update Currency Success': props<{
      currencyShortCode: string;
      fx: number;
      crRate: number;
      symbol: string;
    }>(),
    'Update Currency Failure': props<{ error: string }>(),
  },
});
